import { FC } from 'react';
import type { ReportBlock } from '@/types/blocks';
import { MdTextBlock } from './MdTextBlock';
import { KpiCardBlock } from './KpiCardBlock';
import { TableBlock } from './TableBlock';
import { LineChartBlock } from './LineChartBlock';
import { PieChartBlock } from './PieChartBlock';
import { BarChartBlock } from './BarChartBlock';
import { QuestionFormBlock } from './QuestionFormBlock';

const CHART_TYPES = new Set(['line_chart', 'bar_chart', 'pie_chart']);

const renderBlock = (
  block: ReportBlock,
  index: number,
  chartIndex: number,
  onSubmitPrompt?: (text: string) => void,
  isLastMessage?: boolean,
) => {
  switch (block.type) {
    case 'md_text':
      return <MdTextBlock key={index} block={block} />;
    case 'kpi_card':
      return <KpiCardBlock key={index} block={block} />;
    case 'table':
      return <TableBlock key={index} block={block} />;
    case 'line_chart':
      return (
        <div key={index} data-chart-index={chartIndex}>
          <LineChartBlock block={block} />
        </div>
      );
    case 'pie_chart':
      return (
        <div key={index} data-chart-index={chartIndex}>
          <PieChartBlock block={block} />
        </div>
      );
    case 'bar_chart':
      return (
        <div key={index} data-chart-index={chartIndex}>
          <BarChartBlock block={block} />
        </div>
      );
    case 'question_form':
      return (
        <QuestionFormBlock
          key={index}
          block={block}
          onSubmit={onSubmitPrompt}
          initialSubmitted={!isLastMessage}
        />
      );
    default:
      return null;
  }
};

interface BlockRendererProps {
  blocks: ReportBlock[];
  onSubmitPrompt?: (text: string) => void;
  isLastMessage?: boolean;
}

export const BlockRenderer: FC<BlockRendererProps> = ({ blocks, onSubmitPrompt, isLastMessage }) => {
  let chartIdx = 0;
  return (
    <div className="flex flex-col gap-6">
      {blocks.map((block, i) => {
        const ci = CHART_TYPES.has(block.type) ? chartIdx++ : -1;
        return renderBlock(block, i, ci, onSubmitPrompt, isLastMessage);
      })}
    </div>
  );
};
